import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_135_heads_add: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Account heads",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              margin: 0,
              marginBottom: 16,
            },
            childComponents: [],
          },
          {
            componentType: LayoutTypes.FORM,
            Name: "heads_add",
            TableName: "ledgers",
            DisplayName: "Account heads",
            columnNumber: "m1 t1 w3",
            style: {
              padding: 10,
              backgroundColor: "#ffffff",
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_main_head",
                label: "Main head",
                placeholder: "Select main head",
                required: true,
                lookupName: "main_ledger_heads",
                options: [],
                Json_Attribute: "main_head_id",
                IncludeNotSet: true,
                IsVerticalView: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Main head is required",
                  },
                ],
              },
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_main_head_group",
                label: "Head group",
                placeholder: "Select head group",
                required: true,
                lookupName: "main_head_groups",
                options: [],
                Json_Attribute: "main_head_group_id",
                IncludeNotSet: true,
                IsVerticalView: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Head group is required",
                  },
                ],
              },
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_group",
                label: "Head name",
                placeholder: "Select head name",
                required: true,
                lookupName: "leger_group_without_cash",
                options: [],
                Json_Attribute: "group_id",
                IncludeNotSet: true,
                IsVerticalView: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Head name is required",
                  },
                ],
                // Note: BindScreen functionality (EnableAdding: true, BindScreen: "heads_sub_group_add_from_modal")
                // would need to be implemented separately if modal add functionality is required
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_name",
                label: "Sub name",
                placeholder: "Enter sub name",
                required: true,
                inputType: InputType.TEXT,
                Json_Attribute: "ledger_name",
                IsVerticalView: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Sub name is required",
                  },
                ],
              },
              
              {
                componentType: LayoutTypes.GROUP,
                style: {
                  direction: FlexDirection.ROW,
                  padding: 16,
                  gap: 12,
                },
                childComponents: [
                  {
                    componentType: ComponentType.BUTTON,
                    name: "Submit",
                    Label: "Submit",
                    BindValue: "btn_submit",
                    onPressAction: "save",
                    ActionType: "Add",
                    ScreenId: "135",
                    style: {
                      backgroundColor: "var(--primary-green)",
                      textColor: "#FFFFFF",
                      padding: 12,
                      borderRadius: 6,
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
